// extracted by mini-css-extract-plugin
export default {"status":"TransactionStatus_status__cmz07","status_text":"TransactionStatus_status_text__bitQ3"};